import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo-section">
            <img src="/Logo4.png" alt={t('nav.logoAlt')} className="footer-logo" />
            <p className="footer-mission">
              {t('footer.mission')}
            </p>
          </div>
          <div className="footer-contact">
            <h4>{t('footer.contact')}</h4>
            <p>{t('footer.email')}: contact@tchelp.org</p>
            <p>{t('footer.website')}: tchelp.org</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>{t('footer.copyright')}</p>
          <p className="footer-note">
            {t('footer.note')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
